export const lockPageScrollOnMobileOnly = () => {
  document.documentElement.classList.add('modal-open');
};

export const lockPageScrollAllViewports = () => {
  document.documentElement.classList.add('modal-open-all-viewports');
};
